import { createSlice } from '@reduxjs/toolkit';

import { internalReducer, internalSelector, internalState } from './internal';
import { permissionReducer, permissionState } from './permission';

/** Auth Slice. */
export const authSlice = createSlice({
  name: 'feature_auth',
  initialState: {
    ...internalState,
    ...permissionState,
  },
  reducers: {
    ...internalReducer,
    ...permissionReducer,
  },
  selectors: {
    ...internalSelector,
  },
});

/** Auth Slice Actions. */
export const authSliceActions = authSlice.actions;

/** Auth Slice Selectors. */
export const authSliceSelectors = authSlice.selectors;
